import _ from "ES/lib/lodash";
import React from "ES/lib/react";

var Footer = function(props){
    var buttons_vdom = _.map(props.buttons, function(btn, i){
        return (
            <button
                key={i}
                type="button"
                className={btn.className}
                onClick={btn.onClick}
            >
                {btn.name}
            </button>
       );
    });
    if(_.isEmpty(buttons_vdom)){
        return <div/>;
    }
    return (
        <div className="modal-footer">
            {buttons_vdom}
        </div>
    );
};

export default React.createClass({
    propTypes: {
        title: React.PropTypes.string,
        onClose: React.PropTypes.func,
        is_large: React.PropTypes.bool,
        buttons: React.PropTypes.array
    },
    render: function(){
        var title = this.props.title;
        var body = this.props.children;
        var onClose = _.isFunction(this.props.onClose)
            ? this.props.onClose
            : undefined;
        var is_large = !!this.props.is_large;

        var buttons;
        if(_.isArray(this.props.buttons)){
            buttons = this.props.buttons;
            //empty array means they don't want a button footer at all
        }else{
            buttons = [];
            if(onClose){
                buttons.push({
                    className: "btn btn-default",
                    name: "Close",
                    onClick: onClose
                });
            }
        }

        return (
            <div
                className={"modal-dialog" + (is_large ? " modal-lg" : "")}
                role="document"
            >
                <div className="modal-content">
                    <div className="modal-header">
                        {onClose ? <button type="button" className="close" onClick={onClose}>
                            x
                        </button> : null}
                        <h4 className="modal-title">
                            {title}
                        </h4>
                    </div>
                    <div className="modal-body">
                        {body}
                    </div>
                    <Footer buttons={buttons} />
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/ModalDialog.js